import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID, // Your app's client ID from Azure AD
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`, // Your directory (tenant) ID
    redirectUri: process.env.REACT_APP_URL, // The URL where users are redirected after signing in
  },
  cache: {
    cacheLocation: "localStorage", // Can be 'localStorage' or 'sessionStorage'
    storeAuthStateInCookie: false, // Set to true if you're having issues with Safari
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.INFO, // Change to DEBUG or TRACE for more detail
      loggerCallback: (level, message, containsPii) => {
        // Log messages to the console
      },
    },
  },
};
